import { homepageBreadcrumbs } from './homepageBreadcrumbs'
import { PageContextProvider } from './types'

export const page404: PageContextProvider = (context) => {
  return {
    widgets: [],
    name: '404',
    url: '/404',
    metaTitlePhrase: undefined,
    breadcrumbs: [homepageBreadcrumbs(context.modules)]
  }
}
